import { Turbo } from "@hotwired/turbo-rails";
import Toastify from 'toastify-js'
import "toastify-js/src/toastify.css"

Turbo.StreamActions.open_toast = function () {
  const message = this.getAttribute("message");
  const type = this.getAttribute("type");

  let toastColor = '#0891B2'; // info color

  switch (type) {
    case "success":
      toastColor = "#16A34A";
      break;
    case "error":
      toastColor = "#DC2626";
      break;
    case "warning":
      toastColor = "#F59E0B";
      break;
  }

  Toastify({
    text: message,
    duration: 3000,
    close: true,
    gravity: "bottom", // `top` or `bottom`
    position: "right", // `left`, `center` or `right`
    stopOnFocus: true, // Prevents dismissing of toast on hover
    style: {
      color: "#fff",
      background: toastColor,
    },
    onClick: function(){} // Callback after click
  }).showToast();
};